export default "__VITE_ASSET__bd8d48fa__"